import { createSlice, Middleware } from "@reduxjs/toolkit"
import { calcDetails } from "./types"

type initialState = {
  response: calcDetails | null
}

export const calcDetailsSlice = createSlice({
  name: "calcDetails",
  initialState: { response: null } as initialState,
  reducers: {
    setCalcDetails(state, action) {
      state.response = action.payload
    }
  }
})

export const { setCalcDetails } = calcDetailsSlice.actions
export default calcDetailsSlice.reducer

export const calcDetailsHandlerMiddleware: Middleware = () => (next) => (action) => {
  return next(action)
}
